import { render, staticRenderFns } from "./privacy-policy-en.vue?vue&type=template&id=246ae732&scoped=true"
import script from "./privacy-policy-en.vue?vue&type=script&lang=js"
export * from "./privacy-policy-en.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ae732",
  null
  
)

export default component.exports